import {
  KebabHorizontalIcon,
  PencilIcon,
  PlusIcon,
  TrashIcon,
} from "@primer/octicons-react";
import {
  ActionList,
  ActionMenu,
  Box,
  IconButton,
  useConfirm,
} from "@primer/react";
import { useEffect, useState } from "react";
import { dm_phong } from "../../../models/response/phong/dm_phong";
import { useCommonContext } from "../../../contexts/common";
import { phongApi } from "../../../api/phongApi";
import { NotifyHelper } from "../../../helpers/toast";
import DataTable from "../../../components/ui/data-table";
import TextTranslated from "../../../components/text";
import Button from "../../../components/ui/button";
import PhongDetailModal from "./PhongDetailModal";
const Phong = () => {
  const [isShowModal, setIsShowModal] = useState(false);
  const [isShowDetailModalDangKy, setIsShowDetailModalDangKy] = useState(false);

  const [selectedId, setSelectedId] = useState(0);
  const [Phongs, setPhongs] = useState<dm_phong[]>([]);
  const { translate } = useCommonContext();
  const [isSaving, setIsSaving] = useState(false);
  const confirm = useConfirm();

  useEffect(() => {
    handleReloadAsync();
  }, []);
  const handleReloadAsync = async () => {
    const res = await phongApi.selectAll();
    if (res.is_success) {
      setPhongs(res.data);
    } else {
      NotifyHelper.Error("Có lỗi");
    }
  };

  const handeDelete = async (id: number) => {
    if (
      await confirm({
        content: "Bạn có chắc chắn muốn xóa phòng này?",
        title: "Lưu ý",
        cancelButtonContent: "Không xóa",
        confirmButtonContent: "Xóa phòng",
        confirmButtonType: "danger",
      })
    ) {
      const res = await phongApi.delete(id);
      if (res.is_success) {
        NotifyHelper.Success("Success");
        handleReloadAsync();
      } else {
        NotifyHelper.Error("Có lỗi");
      }
    }
  };
  return (
    <Box sx={{ p: 3 }}>
      <DataTable
        height={`${window.innerHeight - 250}px`}
        columns={[
          {
            id: "cmd",
            width: "50px",
            caption: "",
            align: "center",
            cellRender: (data: dm_phong) => {
              return (
                <ActionMenu>
                  <ActionMenu.Anchor>
                    <IconButton
                      icon={KebabHorizontalIcon}
                      variant="invisible"
                      aria-label="Open column options"
                    />
                  </ActionMenu.Anchor>

                  <ActionMenu.Overlay>
                    <ActionList>
                      <ActionList.Item
                        onSelect={() => {
                          setIsShowModal(true);
                          if (data.id !== undefined) {
                            setSelectedId(data.id);
                          }
                        }}
                      >
                        <ActionList.LeadingVisual>
                          <PencilIcon />
                        </ActionList.LeadingVisual>
                        <TextTranslated value="Base.Label.Edit" />
                      </ActionList.Item>
                      <ActionList.Divider />
                      <ActionList.Item
                        variant="danger"
                        onSelect={() => {
                          if (data.id !== undefined) {
                            handeDelete(data.id);
                          }
                        }}
                      >
                        <ActionList.LeadingVisual>
                          <TrashIcon />
                        </ActionList.LeadingVisual>
                        <TextTranslated value="Base.Label.Delete" />
                      </ActionList.Item>
                    </ActionList>
                  </ActionMenu.Overlay>
                </ActionMenu>
              );
            },
          },
          {
            dataField: "toa",
            width: "auto",
            caption: `Tòa`,
            cellRender: (data: dm_phong) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "baseline",
                    whiteSpace: "nowrap",
                  }}
                >
                  {data.toa}
                </Box>
              );
            },
          },
          {
            dataField: "ten_phong",
            width: "auto",
            isMainColumn: true,
            caption: `Tên phòng`,
            cellRender: (data: dm_phong) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "baseline",
                    whiteSpace: "nowrap",
                  }}
                >
                  {data.ten_phong || "..."}
                </Box>
              );
            },
          }        
        ]}
        data={Phongs}
        title="Phòng"
        subTitle={`${translate("Base.Label.TotalCount")}: ${Phongs.length}`}
        searchEnable
        actionComponent={
          <>
            <Button
              text={translate("Base.Label.Create")}
              leadingVisual={PlusIcon}
              variant="primary"
              size="medium"
              onClick={() => {
                setIsShowModal(true);
                setSelectedId(0);
              }}
            />
          </>
        }
      />
      {isShowModal && (
        <PhongDetailModal
          id={selectedId}
          onClose={() => {
            setIsShowModal(false);
          }}
          onSuccess={() => {
            handleReloadAsync();
            setIsShowModal(false);
          }}
        />
      )}
    </Box>
  );
};

export default Phong;
